"use strict";
/*!
 * Copyright 2021 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _asyncIterator = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var document_1 = require("./document");

var util_1 = require("./util");

var logger_1 = require("./logger");
/**
 * A wrapper around BatchGetDocumentsRequest that retries request upon stream
 * failure and returns ordered results.
 *
 * @private
 * @internal
 */


var DocumentReader =
/*#__PURE__*/
function () {
  /**
   * Creates a new DocumentReader that fetches the provided documents (via
   * `get()`).
   *
   * @param firestore The Firestore instance to use.
   * @param allDocuments The documents to get.
   */
  function DocumentReader(firestore, allDocuments) {
    _classCallCheck(this, DocumentReader);

    this.firestore = firestore;
    this.allDocuments = allDocuments;
    this.outstandingDocuments = new Set();
    this.retrievedDocuments = new Map();
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this.allDocuments[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var docRef = _step2.value;
        this.outstandingDocuments.add(docRef.formattedName);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
  /**
   * Invokes the BatchGetDocuments RPC and returns the results.
   *
   * @param requestTag A unique client-assigned identifier for this request.
   */


  _createClass(DocumentReader, [{
    key: "get",
    value: function get(requestTag) {
      var orderedDocuments, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, docRef, document, finalDoc;

      return _regeneratorRuntime.async(function get$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _regeneratorRuntime.awrap(this.fetchDocuments(requestTag));

            case 2:
              // BatchGetDocuments doesn't preserve document order. We use the request
              // order to sort the resulting documents.
              orderedDocuments = [];
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context.prev = 6;
              _iterator3 = this.allDocuments[Symbol.iterator]();

            case 8:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context.next = 24;
                break;
              }

              docRef = _step3.value;
              document = this.retrievedDocuments.get(docRef.formattedName);

              if (!(document !== undefined)) {
                _context.next = 20;
                break;
              }

              // Recreate the DocumentSnapshot with the DocumentReference
              // containing the original converter.
              finalDoc = new document_1.DocumentSnapshotBuilder(docRef);
              finalDoc.fieldsProto = document._fieldsProto;
              finalDoc.readTime = document.readTime;
              finalDoc.createTime = document.createTime;
              finalDoc.updateTime = document.updateTime;
              orderedDocuments.push(finalDoc.build());
              _context.next = 21;
              break;

            case 20:
              throw new Error("Did not receive document for \"".concat(docRef.path, "\"."));

            case 21:
              _iteratorNormalCompletion3 = true;
              _context.next = 8;
              break;

            case 24:
              _context.next = 30;
              break;

            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](6);
              _didIteratorError3 = true;
              _iteratorError3 = _context.t0;

            case 30:
              _context.prev = 30;
              _context.prev = 31;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 33:
              _context.prev = 33;

              if (!_didIteratorError3) {
                _context.next = 36;
                break;
              }

              throw _iteratorError3;

            case 36:
              return _context.finish(33);

            case 37:
              return _context.finish(30);

            case 38:
              return _context.abrupt("return", orderedDocuments);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[6, 26, 30, 38], [31,, 33, 37]]);
    }
  }, {
    key: "fetchDocuments",
    value: function fetchDocuments(requestTag) {
      var request, fieldPaths, resultCount, stream, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, response, snapshot, path, shouldRetry;

      return _regeneratorRuntime.async(function fetchDocuments$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (this.outstandingDocuments.size) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              request = {
                database: this.firestore.formattedName,
                transaction: this.transactionId,
                documents: Array.from(this.outstandingDocuments)
              };

              if (this.fieldMask) {
                fieldPaths = this.fieldMask.map(function (fieldPath) {
                  return fieldPath.formattedName;
                });
                request.mask = {
                  fieldPaths: fieldPaths
                };
              }

              resultCount = 0;
              _context2.prev = 5;
              _context2.next = 8;
              return _regeneratorRuntime.awrap(this.firestore.requestStream('batchGetDocuments', request, requestTag));

            case 8:
              stream = _context2.sent;
              stream.resume();
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context2.prev = 12;
              _iterator = _asyncIterator(stream);

            case 14:
              _context2.next = 16;
              return _regeneratorRuntime.awrap(_iterator.next());

            case 16:
              _step = _context2.sent;
              _iteratorNormalCompletion = _step.done;
              _context2.next = 20;
              return _regeneratorRuntime.awrap(_step.value);

            case 20:
              _value = _context2.sent;

              if (_iteratorNormalCompletion) {
                _context2.next = 32;
                break;
              }

              response = _value;
              snapshot = void 0;

              if (response.found) {
                logger_1.logger('DocumentReader.fetchDocuments', requestTag, 'Received document: %s', response.found.name);
                snapshot = this.firestore.snapshot_(response.found, response.readTime);
              } else {
                logger_1.logger('DocumentReader.fetchDocuments', requestTag, 'Document missing: %s', response.missing);
                snapshot = this.firestore.snapshot_(response.missing, response.readTime);
              }

              path = snapshot.ref.formattedName;
              this.outstandingDocuments.delete(path);
              this.retrievedDocuments.set(path, snapshot);
              ++resultCount;

            case 29:
              _iteratorNormalCompletion = true;
              _context2.next = 14;
              break;

            case 32:
              _context2.next = 38;
              break;

            case 34:
              _context2.prev = 34;
              _context2.t0 = _context2["catch"](12);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 38:
              _context2.prev = 38;
              _context2.prev = 39;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context2.next = 43;
                break;
              }

              _context2.next = 43;
              return _regeneratorRuntime.awrap(_iterator.return());

            case 43:
              _context2.prev = 43;

              if (!_didIteratorError) {
                _context2.next = 46;
                break;
              }

              throw _iteratorError;

            case 46:
              return _context2.finish(43);

            case 47:
              return _context2.finish(38);

            case 48:
              _context2.next = 59;
              break;

            case 50:
              _context2.prev = 50;
              _context2.t1 = _context2["catch"](5);
              shouldRetry = // Transactional reads are retried via the transaction runner.
              !this.transactionId && // Only retry if we made progress.
              resultCount > 0 && // Don't retry permanent errors.
              _context2.t1.code !== undefined && !util_1.isPermanentRpcError(_context2.t1, 'batchGetDocuments');
              logger_1.logger('DocumentReader.fetchDocuments', requestTag, 'BatchGetDocuments failed with error: %s. Retrying: %s', _context2.t1, shouldRetry);

              if (!shouldRetry) {
                _context2.next = 58;
                break;
              }

              return _context2.abrupt("return", this.fetchDocuments(requestTag));

            case 58:
              throw _context2.t1;

            case 59:
              _context2.prev = 59;
              logger_1.logger('DocumentReader.fetchDocuments', requestTag, 'Received %d results', resultCount);
              return _context2.finish(59);

            case 62:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this, [[5, 50, 59, 62], [12, 34, 38, 48], [39,, 43, 47]]);
    }
  }]);

  return DocumentReader;
}();

exports.DocumentReader = DocumentReader;